/* import __COLOCATED_TEMPLATE__ from './chunkability-score.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type ArticleContent from 'embercom/models/articles/article-content';

interface Args {
  activeContent: ArticleContent;
}

export default class ChunkabilityScore extends Component<Args> {
  get score(): number {
    return this.args.activeContent.chunkabilityScore;
  }

  get stampColor(): string {
    if (this.score > 50) {
      return 'green';
    } else if (this.score >= 30) {
      return 'yellow';
    }
    return 'red';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::Shared::DataSection::ChunkabilityScore': typeof ChunkabilityScore;
    'knowledge-hub/content-editor/shared/data-section/chunkability-score': typeof ChunkabilityScore;
  }
}
